// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/styles/main.scss
// module id = 2571
// module chunks = 0